import * as React from 'react'

function useLocalStorage<T>(key: string, initialValue: T | (() => T)) {
	const [state, setState] = React.useState<T>(() => {
		const storedValue = key ? localStorage.getItem(key) : undefined
		if (storedValue) {
			try {
				return JSON.parse(storedValue)
			} catch (_e) {}
		}

		return initialValue as T
	})
	const stateRef = React.useRef(state)
	const setValue = React.useCallback(
		(value: T | ((state: T) => T)) => {
			const newValue =
				typeof value === 'function'
					? (value as (state: T) => T)(stateRef.current)
					: value

			setState(newValue)

			key && localStorage.setItem(key, JSON.stringify(newValue))
		},
		[key],
	)

	React.useEffect(() => {
		stateRef.current = state
	}, [state])

	return [state, setValue] as const
}

export { useLocalStorage as default }
